import { useInject } from '@back-office/submerchant';
import { observer } from 'mobx-react';
import React, { PropsWithChildren } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

const PublicRoute = observer((props: PropsWithChildren<RouteProps>) => {
  const { children, ...rest } = props;
  const { isAuth } = useInject((store) => store.auth);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuth ? (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        ) : (
          children
        )
      }
    />
  );
});

export default PublicRoute;
